module.exports = __webpack_public_path__ + "media/images/produtos-e-marcas-1-6ac8d29280f5036503e0655690185f87.jpg";